import {FC} from 'react';
import {useFullscreenToggle} from '../../hooks/useFullscreenToggle';
import {useIsFullscreen} from '../../hooks/usePlayerState';
import {ControlButton} from '../controlButton';
import EnterFullscreenIcon from './enterFullscreenIcon.svg';
import ExitFullscreenIcon from './exitFullscreenIcon.svg';

export const FullscreenButton: FC = () => {
  const isFullscreen = useIsFullscreen();
  const [onClick, isAvailable] = useFullscreenToggle();
  const label = isFullscreen ? 'Exit Full Screen' : 'Enter Full Screen';

  if (!isAvailable) return null;

  return (
    <ControlButton
      ariaLabel={label}
      ariaPressed={isFullscreen}
      tooltipLabel={label}
      onClick={onClick}
    >
      {isFullscreen ? <ExitFullscreenIcon /> : <EnterFullscreenIcon />}
    </ControlButton>
  );
};
